<template>
    <b-row>
        <div class="col-sm-12 mt-3">
            <h3>
                Crear usuario
            </h3>
        </div>
        <div class="col-sm-12 mt-3">
            <label for="" class="form-label">Nombre</label>
            <input type="text" class="form-control form-control-sm" v-model="nombre">
        </div>
        <div class="col-sm-12 mt-3">
            <label for="" class="form-label">Usuario</label>
            <input type="text" class="form-control form-control-sm" autocomplete="off" v-model="usuario">
        </div>
        <div class="col-sm-6 mt-3">
            <label for="" class="form-label">Contraseña</label>
            <input type="password" class="form-control form-control-sm" v-model="pass">
        </div>
        <div class="col-sm-6 mt-3">
            <label for="" class="form-label">Confirmar contraseña</label>
            <input type="password" class="form-control form-control-sm" v-model="pass2">
        </div>
        <!-- <div class="col-sm-12 mt-3">
            <label for="" class="form-label">Perfil</label>
            <select class="form-control form-control-sm" v-model="rol">
                <option value="">Seleccionar</option>
                <option v-for="(item, index) in roles" :key="index" :value="item.id">{{ item.name }}</option>
            </select>
        </div> -->
        <div class="col-sm-10 mt-4">
            <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                @click="registrar_usuario">Guardar</button>
        </div>
        <div class="col-sm-2 mt-4">
            <button type="button" class="btn btn-sm btn-outline-dark btn-block"
                @click="cerrar_formulario">Volver</button>
        </div>
    </b-row>
</template>

<script>
    import { minix, atexto } from '@/components/functions/alertas';
    import moment from 'moment';
    import { mapActions, mapState } from 'vuex';

    export default {
        name: 'CrearUsuario',
        computed: {
            ...mapState(['roles', 'sucursal_seleccionada', 'id_empresa_seleccionada'])
        },
        data() {
            return {
                nombre: '',
                usuario: '',
                correo: '',
                pass: '',
                pass2: '',
                rol: ''
            }
        },
        methods: {
            async registrar_usuario() {
                if (this.nombre.trim() === '' || this.usuario.trim() === '' || this.pass.trim() === '' || this.pass2.trim() === '') {
                    minix({ icon: 'error', mensaje: 'Todos los campos son obligatorios', tiempo: 3000 })
                } else {
                    // Validación del nombre de usuario
                    const usuarioRegex = /^[a-z][a-z0-9]{4,}$/;

                    if (!usuarioRegex.test(this.usuario)) {
                        atexto({
                            titulo: 'Incumplimientos', 
                            cuerpo: 'El nombre de usuario debe cumplir con los siguientes requisitos: <br><br>' +
                                '- Mínimo 5 caracteres <br>' +
                                '- No puede contener mayúsculas <br>' +
                                '- No puede iniciar con un número <br>' +
                                '- No puede contener espacios', 
                            icono: 'warning'
                        })
                        return;
                    }

                    // Validación de contraseña con expresión regular
                    const passwordRegex = /^(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])[^\s]{8,}$/;

                    if (!passwordRegex.test(this.pass)) {
                        atexto({
                            titulo: 'Incumplimientos', 
                            cuerpo: 'La contraseña debe cumplir con los siguientes requisitos: <br><br>' +
                                '- Mínimo 8 caracteres <br>' +
                                '- Al menos una letra mayúscula <br>' +
                                '- Al menos un número <br>' +
                                '- Al menos un caracter especial (!@#$%^&*) <br>' +
                                '- No debe contener espacios', 
                            icono: 'warning'
                        })
                        return;
                    }

                    if (this.pass.trim() === this.pass2.trim()) {
                        let f = {
                            api: 'users',
                            formulario: {
                                username: this.usuario.trim().toLocaleLowerCase(),
                                email: moment(Date.now()).format('YYYYMMDDHHmmss') + '@correo.com',
                                password: this.pass.trim(),
                                role: 1,
                                confirmed: true,
                                blocked: false,
                                nombre_completo: this.nombre.toUpperCase().trim(),
                                sucursal_asignada: this.sucursal_seleccionada.codigo,
                                nivel: 1,
                                empresa: this.id_empresa_seleccionada,
                                sucursales_asignadas: {},
                                parametros: {
                                    "roles": [
                                        "VENDEDOR"
                                    ],
                                    "modulos": [
                                        "FACTURADOR"
                                    ]
                                }
                            }
                        }

                        await this.crear_usuario(f)
                        await this.obtener_vendedores()
                        this.nombre = ''
                        this.usuario = ''
                        this.correo = ''
                        this.pass = ''
                        this.pass2 = ''
                        this.rol = ''
                    } else {
                        minix({ icon: 'error', mensaje: 'Las contraseñas no coinciden', tiempo: 3000 })
                    }
                }
            },
            cerrar_formulario() {
                this.$emit('actualizar_modulo')
            },
            ...mapActions(['crear_usuario', 'obtener_roles', 'obtener_usuarios', 'obtener_vendedores'])
        },
        mounted() {
            this.obtener_roles()
        },
    }
</script>

<style></style>